import React from 'react';
import { formatWorkTimes, isBetweenTime } from './utils';
import moment from 'moment';
import Collapse from '@material-ui/core/Collapse';
import { useTranslation } from 'react-i18next';

const WorkTimes = (props) => {
  const [expandedWorkTimes, setExpandedWorkTimes] = React.useState(false);
  const { t } = useTranslation();

  const { placeData, workTimes, regionsBySysname } = props;

  const formattedWorkTimes = formatWorkTimes(workTimes);

  const now = moment();
  const { timezone } = regionsBySysname[placeData.region];
  const weekdayIsoNumber = now.isoWeekday();
  const currentTimeInPlaceTimeZone = now.clone()
    .tz(timezone)
    .format('LT');
  const currentDayWorkTimes = formattedWorkTimes[weekdayIsoNumber];

  const isOpen = !currentDayWorkTimes ? false : isBetweenTime(
    currentDayWorkTimes,
    currentTimeInPlaceTimeZone
  );

  const handleExpandWorkTimes = () => {
    setExpandedWorkTimes(!expandedWorkTimes);
  };

  return (
    <div className="work-times">
              <span
                onClick={handleExpandWorkTimes}
                className={`
                expand-work-times 
                ${isOpen ? 'open' : 'close'}
                ${expandedWorkTimes ? 'display-none' : ''}
                `}
              >
                {t(`placeInfo.workTimes`)}
              </span>
      <Collapse in={expandedWorkTimes} timeout="auto" unmountOnExit addEndListener={() => {}}>
        <div onClick={handleExpandWorkTimes} className="work-time-rows-cnt">
          {
            Object.entries(workTimes).map(([key, value]) => {
              const className = +key === +weekdayIsoNumber ? 'current' : '';
              return (
                <span className={`work-time-row ${className} ${isOpen ? 'open' : 'close'}`} key={`day-${key}`}>
                          {value}
                        </span>
              )
            })
          }
        </div>
      </Collapse>
    </div>
  );
}

export default WorkTimes;
